export enum DatePickerMode {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year',
  DUAL_MONTH_DAY = 'dual-month-day'
}
